<!-- Header -->
<h3 mat-dialog-title
	style="color: #a20000; text-align: center;">
	No Class Selected
</h3>

<!-- Body -->
<mat-dialog-content>
	At least one class must be selected.
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">

	<!-- Right Buttons -->
	<div class="footerRight">
		<tyl-button image="save.png"
			label="OK"
			(clickEvent)="ok()"></tyl-button>
	</div>
</mat-dialog-actions>